export default __webpack_public_path__ + "static/media/login-segment-mail-icon.b84a702d.svg";